import { gql } from "@apollo/client";

export const GET_DAILY_LOWEST_PRICES = gql`
  query getDailyLowestPrices($accommodationTypeId: ID!, $from: Date!, $until: Date!) {
    dailyLowestPrices(accommodationTypeId: $accommodationTypeId, from: $from, until: $until) {
      date
      price {
        withDiscount
      }
    }
  }
`;
